module.exports = __webpack_public_path__ + "static/media/26UNRWA17.09c59444.jpg";